import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Title, { flushTitle } from 'reactjs-title'

export default function CompanyRep(props) {
  const { profile } = props;
  const full_name = `${profile.first_name} ${profile.last_name}`
  return (
    <Paper square={true} elevation={4}>
    <Grid container direction="row" justify="space-between" alignItems="center" >
      <Grid item>
        <ListItem key={profile.id}>
          <ListItemAvatar>
            <Avatar src={profile.picture.thumb.url} alt={profile.first_name} />
          </ListItemAvatar>
          <ListItemText primary={full_name} secondary={profile.display_title} />
        </ListItem>
      </Grid>
      <Grid item>
        {props.actions}
      </Grid>
    </Grid>
  </Paper>
  );
}
